"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _basic_data_hub_api = _interopRequireDefault(require("./basic_data_hub_api"));

var _constants = require("./lib/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CloneApi =
/*#__PURE__*/
function (_BasicDataHubApi) {
  (0, _inherits2.default)(CloneApi, _BasicDataHubApi);

  /**
   * @constructor
   */
  function CloneApi(_ref) {
    var _this;

    var dataHubUrl = _ref.dataHubUrl,
        userTokenFactory = _ref.userTokenFactory,
        onGraphQLErrors = _ref.onGraphQLErrors,
        onNetworkError = _ref.onNetworkError,
        deployerUrl = _ref.deployerUrl,
        accountId = _ref.accountId,
        defaultLimit = _ref.defaultLimit;
    (0, _classCallCheck2.default)(this, CloneApi);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CloneApi).call(this, {
      dataHubUrl: dataHubUrl,
      userTokenFactory: userTokenFactory,
      onGraphQLErrors: onGraphQLErrors,
      onNetworkError: onNetworkError,
      accountId: accountId,
      defaultLimit: defaultLimit
    }));
    _this.deployerUrl = deployerUrl;
    return _this;
  }

  (0, _createClass2.default)(CloneApi, [{
    key: "cloneCard",
    value: function () {
      var _cloneCard = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(cardId) {
        var viewIds,
            binding,
            method,
            accountId,
            _args = arguments;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                viewIds = _args.length > 1 && _args[1] !== undefined ? _args[1] : [];
                _context.next = 3;
                return this.getBinding();

              case 3:
                binding = _context.sent;
                method = this._getMethodName('cloneCard');
                accountId = this.accountId;
                return _context.abrupt("return", binding.mutation[method](_objectSpread({
                  entity: _constants.CARD,
                  cardId: cardId,
                  params: {
                    holderIds: viewIds,
                    holderType: null,
                    cloneDeep: false
                  }
                }, accountId ? {
                  accountId: accountId
                } : {})));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function cloneCard(_x) {
        return _cloneCard.apply(this, arguments);
      }

      return cloneCard;
    }()
  }, {
    key: "cloneFlowToBots",
    value: function () {
      var _cloneFlowToBots = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(flowId, botIds, cloneDeep) {
        var binding, method, accountId;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getBinding();

              case 2:
                binding = _context2.sent;
                method = this._getMethodName('cloneFlow');
                accountId = this.accountId;
                return _context2.abrupt("return", binding.mutation[method](_objectSpread({
                  flowId: flowId,
                  params: {
                    holderIds: botIds,
                    cloneDeep: cloneDeep
                  }
                }, accountId ? {
                  accountId: accountId
                } : {})));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function cloneFlowToBots(_x2, _x3, _x4) {
        return _cloneFlowToBots.apply(this, arguments);
      }

      return cloneFlowToBots;
    }()
  }, {
    key: "cloneView",
    value: function () {
      var _cloneView = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(viewId, cloneDeep) {
        var linkIds,
            linkType,
            binding,
            method,
            accountId,
            _args3 = arguments;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                linkIds = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : [];
                linkType = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : null;
                _context3.next = 4;
                return this.getBinding();

              case 4:
                binding = _context3.sent;
                method = this._getMethodName('cloneView');
                accountId = this.accountId;
                return _context3.abrupt("return", binding.mutation[method](_objectSpread({
                  entity: _constants.VIEW,
                  viewId: viewId,
                  params: {
                    holderIds: linkIds,
                    holderType: linkType,
                    cloneDeep: cloneDeep
                  }
                }, accountId ? {
                  accountId: accountId
                } : {})));

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function cloneView(_x5, _x6) {
        return _cloneView.apply(this, arguments);
      }

      return cloneView;
    }()
  }]);
  return CloneApi;
}(_basic_data_hub_api.default);

var _default = CloneApi;
exports.default = _default;